export default __webpack_public_path__ + "static/media/MTF.c3c70d7a.png";